import { useEffect } from 'react';
import {
    useDispatch, useSelector
} from 'react-redux';

import {
    AppState, closeModal, ModalManagerState, ModalVariants, openModal
} from '../../app';

/**
 * Watches the session idle timeout in the store,
 * based on this, show or close the session timeout modal.
 */
export const SessionManager = () => {
    const isIdleExpired = useSelector<AppState, boolean>(
        state => state.session.isIdleTimedOut
    );
    const sessionExpired = useSelector<AppState, boolean>(
        state => state.session.isSessionExpired
    );
    const currentModal = useSelector<AppState, ModalManagerState['currentModal']>(
        state => state.modalManager.currentModal
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if ((isIdleExpired && !sessionExpired) && currentModal?.variant !== ModalVariants.idleSessionTimeout) {
            dispatch(openModal({ variant: ModalVariants.idleSessionTimeout }));

            return;
        }

        if ((!isIdleExpired) && currentModal?.variant === ModalVariants.idleSessionTimeout) {
            dispatch(closeModal());

            return;
        }

        if ((sessionExpired) && currentModal?.variant !== ModalVariants.sessionTimeout) {
            dispatch(openModal({ variant: ModalVariants.sessionTimeout }));

            return;
        }

        if ((!sessionExpired) && currentModal?.variant === ModalVariants.sessionTimeout) {
            dispatch(closeModal());

            return;
        }
    }, [dispatch, isIdleExpired, currentModal?.variant, sessionExpired]);

    return null;
};
